// extracted by mini-css-extract-plugin
export default {"container":"tXyxnbEPDU5nanupvqEw","pillOuter":"HXs84LGEU8wZY9xJR_FQ"};